import { longBranchConfig } from "./data";
import CityPageTemplate from "@/pages/city-template/CityPageTemplate";

export default function LongBranchPage() {
  return <CityPageTemplate config={longBranchConfig} />;
}